var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "23 12 23 67 63.001 67 63.001 23 52.001 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#DEDFE1",
    points: "52 12 52 23 63 34 63 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,19.52 L28,17 L47.023,17 L47.023,19.52 L28,19.52 Z M28,25.252 L28,22.733 L47.023,22.733 L47.023,25.252 L28,25.252 Z M28,30.986 L28,28.466 L47.023,28.466 L47.023,30.986 L28,30.986 Z",
    id: "Combined-Shape",
    fill: "#777A80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#51C25D",
    points: "52 12 52 23 63 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#DEDFE1",
    points: "45 59.042 71 59.042 71 39 45 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#51C25D",
    points: "63.3662466 45.626 58.6334413 45.506 53.0273085 52.033 48.8503492 49.769 45 52.227 45 59.006 71 59.006 71 41.243 67.7582413 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#1D9042",
    points: "67.7582413 50.3293661 63.2506144 52.5492885 58.6334413 49.8791721 53.0273085 56.0794308 48.8503492 52.7583441 45 54.4194049 45 59 71 59 71 47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(12.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5614,24.79 C1.3104,22.197 -1.6546,15.028 0.9384,8.777 C3.5314,2.526 10.7004,-0.439 16.9514,2.154 L7.5614,24.79 Z",
    id: "Fill-11",
    fill: "#51C25D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.951,2.1543 C23.201,4.7473 26.167,11.9163 23.574,18.1673 C20.981,24.4173 13.812,27.3833 7.561,24.7903 L16.951,2.1543 Z",
    id: "Fill-14",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8378,0.0156 C23.1118,2.2056 26.8228,7.4056 26.8228,13.4716 L12.2558,13.4716 L17.8378,0.0156 Z",
    id: "Fill-16",
    fill: "#1D9042"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.034993c1c4ad5e5a7cca24939746d3b0.svg";
export { ForwardRef as ReactComponent };